module.exports = __webpack_public_path__ + "src/assets/svgs/landing/just-white-logo.svg";